import React, { useContext, useEffect, useState } from 'react'
import { AppContext } from 'stores/AppStore'
import { useTranslation } from 'react-i18next'
import { UserContext } from 'stores/UserStore'
import { InspectionReportContext } from 'stores/InspectionReportStore'
import { LoadingOverlay, FlexView, Icon, Card, Button, Spinner } from 'components/common'
import { useHistory } from 'react-router-dom'
// import styled from 'styled-components'
import moment from 'moment'
import ApprovalModal from 'containers/inspection-report/ApprovalModal'
import RejectModal from 'containers/inspection-report/RejectModal'
import InternalApprovalModal from 'containers/inspection-report/InternalApprovalModal'

// const GridDetail = styled(FlexView)`
//   display: grid;
//   grid-template-columns: repeat(4, minMax(0, 5fr));
// `

const InspectionReportApprovalPage = () => {
  const DEFAULT_URL = "inspection-report";
  const history = useHistory();
  const { t } = useTranslation();
  const { currentUser, registryLog } = useContext(UserContext);
  const { setPageSubtitle } = useContext(AppContext);
  const {
    reportToApproval,
    getInspectionReportApprovalData,
    approvalType,
  } = useContext(InspectionReportContext);
  const [loading, setLoading] = useState(true);
  const [loadingDocument, setLoadingDocument] = useState(false);
  const [showPDFCard, setShowPDFCard] = useState(true);
  const [showApproveModal, setShowApproveModal] = useState(false);
  const toggleApproveModal = () =>
    setShowApproveModal((currentApproveState) => !currentApproveState);
  const [showInternalApproveModal, setShowInternalApproveModal] = useState(
    false
  );
  const toggleInternalApproveModal = () =>
    setShowInternalApproveModal(
      (currentInternalApproveState) => !currentInternalApproveState
    );
  const [showRejectModal, setShowRejectModal] = useState(false);
  const toggleRejectModal = () =>
    setShowRejectModal((currentRejectState) => !currentRejectState);

  const [uploadedFileToApprove, setUploadedFileToApprove] = useState(null);

  useEffect(() => {
    setLoading(true);
    if (!reportToApproval) {
      history.replace("/inspection-report");
    } else {
      //registryLogOld("Approval Page In", DEFAULT_URL);
      registryLog(DEFAULT_URL, "navigation", "page_in");
      setLoading(true);
      getInspectionReportApprovalData()
        .then(() => {
          setLoadingDocument(true);
        })
        .catch((e) => {
          console.debug(e);
        })
        .finally(() => setLoading(false));
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setPageSubtitle(t("inspectionReportApproval.pageTitle"));
  }, [setPageSubtitle, t]);

  const onBack = () => {
    //registryLogOld("Approval Page Back", DEFAULT_URL);
    registryLog(DEFAULT_URL, "navigation", "page_out");
    history.replace("/inspection-report");
  };

  const onInternalApproval = () => {
    setShowInternalApproveModal(true);
  };

  const onApproval = () => {
    setShowApproveModal(true);
  };

  const onReject = () => {
    setShowRejectModal(true);
  };

  const onLoadDocument = () => {
    setTimeout(() => {
      setLoadingDocument(false);
    }, 1000);
  };

  const onRetractClick = () => {
    setShowPDFCard(false);
  };

  const onExpandClick = () => {
    setShowPDFCard(true);
  };

  const DetailProperty = ({ name, value }) => {
    return (
      <FlexView
        flexDirection="row"
        justifyContent="flex-start"
        margin="8px 20px"
      >
        <FlexView fontSize="small" color="metalic" margin="0px 10px 0px 0px">
          {name}:
        </FlexView>
        <FlexView fontSize="small">{value || "-"}</FlexView>
      </FlexView>
    );
  };

  useEffect(() => {
    if (uploadedFileToApprove) {
      console.log(
        "file was uploaded and something should be done with it...",
        uploadedFileToApprove
      );
    }
  }, [uploadedFileToApprove]);

  return reportToApproval ? (
    <FlexView flex="1" position="relative" alignSelf="stretch">
      <FlexView
        flexDirection="row"
        alignItems="center"
        justifyContent="flex-start"
        alignSelf="stretch"
        margin="16px 250px 0px"
      >
        <Icon
          name="arrow-left"
          width="28px"
          height="28px"
          onClick={onBack}
        ></Icon>
        <FlexView fontSize="big" fontWeight="bold" margin="0px 8px 0px 8px">
          {t("inspectionReportApproval.report")}:
        </FlexView>
        <FlexView
          fontSize="big"
          fontWeight="bold"
          color="primary"
          margin="0px 8px 0px 8px"
        >
          {reportToApproval.report_id}
        </FlexView>
      </FlexView>

      {showPDFCard ? (
        <Card
          margin="16px 250px"
          alignItems="stretch"
          alignSelf="stretch"
          padding="16px"
        >
          <FlexView
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
            alignSelf="stretch"
          >
            <FlexView
              fontSize="big"
              flexDirection="row"
              alignItems="center"
              fontWeight="bold"
              margin="0px 0px 8px"
            >
              PDF{" "}
              {loadingDocument ? (
                <Spinner style={{ margin: "0px 5px" }} size="medium" />
              ) : null}
            </FlexView>
            <Icon
              name="retract"
              width="20px"
              height="20px"
              style={{ marginBottom: "5px" }}
              onClick={onRetractClick}
            />
          </FlexView>

          <FlexView flexDirection="row">
            <FlexView
              width="75%"
              height="500px"
              alignItems="left"
              alignSelf="left"
              justifyContent="center"
              flexDirection="row"
            >
              {reportToApproval.document ? (
                <iframe
                  title="report"
                  src={reportToApproval.document}
                  style={{ width: "100%", height: "100%", border: 0 }}
                  onLoad={onLoadDocument}
                ></iframe>
              ) : null}
            </FlexView>

            <FlexView
              flexDirection="column"
              alignItems="left"
              alignSelf="stretch"
              width="25%"
              margin="0px 10px"
            >
              <FlexView
                fontSize="big"
                fontWeight="bold"
                alignSelf="center"
                margin="0px 0px 8px"
                flexDirection="row"
              >
                {t("inspectionReportApproval.reportDetail")}
              </FlexView>
              <DetailProperty
                name={t("inspectionReportApproval.sot")}
                value={reportToApproval.sot}
              />
              <DetailProperty
                name={t("inspectionReportApproval.id")}
                value={reportToApproval.report_id}
              />
              <DetailProperty
                name={t("inspectionReportApproval.version")}
                value={reportToApproval.report_version}
              />
              <DetailProperty
                name={t("inspectionReportApproval.item")}
                value={reportToApproval.sot_item}
              />

              <DetailProperty
                name={t("inspectionReportApproval.inspectionDate")}
                value={moment
                  .utc(reportToApproval.inspection_date)
                  .format("DD/MM/YYYY")}
              />
              <DetailProperty
                name={t("inspectionReportApproval.creationDate")}
                value={moment
                  .utc(reportToApproval.report_date)
                  .format("DD/MM/YYYY")}
              />
              <DetailProperty
                name={t("inspectionReportApproval.internalApprovalDate")}
                value={moment
                  .utc(reportToApproval.internal_approval_date)
                  .format("DD/MM/YYYY")}
              />

              {reportToApproval.tpi_event_date && (
                <DetailProperty
                  name={t("inspectionReportApproval.tpiApprovalDate")}
                  value={moment
                    .utc(reportToApproval.tpi_event_date)
                    .format("DD/MM/YYYY")}
                />
              )}

              {(reportToApproval.next_workflow_status === "to-tpi-approval" &&
                currentUser.roles.INSPECTION_REPORT.TPI_APPROVAL) ||
              (reportToApproval.next_workflow_status ===
                "to-customer-approval" &&
                (currentUser.roles.INSPECTION_REPORT.CUSTOMER_APPROVAL ||
                  currentUser.roles.INSPECTION_REPORT.INTERNAL_APPROVAL)) ? (
                <FlexView
                  flexDirection="column"
                  justifyContent="start"
                  margin="5px"
                  alignItems="center"
                >
                  {reportToApproval.next_workflow_status ===
                    "to-customer-approval" && (
                    <>
                      {approvalType &&
                        approvalType === "to-internal-approval" &&
                        currentUser.roles.INSPECTION_REPORT
                          .INTERNAL_APPROVAL && (
                          <>
                            <Button
                              backgroundColor="secondary"
                              color="white"
                              fontSize="medium"
                              margin="10px 0px 0px 10px"
                              onClick={onInternalApproval}
                            >
                              {t("inspectionReportApproval.internal-approve")}
                            </Button>
                            <Button
                              backgroundColor="secondary"
                              color="white"
                              fontSize="medium"
                              margin="10px 0px 0px 10px"
                              onClick={() =>
                                document
                                  .getElementById("fileToApproveInput")
                                  .click()
                              }
                            >
                              <input
                                id="fileToApproveInput"
                                type="file"
                                onChange={(e) => {
                                  setUploadedFileToApprove(e.target.files[0]);
                                }}
                                className="file-upload-button"
                              />
                              {t(
                                "inspectionReportApproval.approveWithSignedDoc"
                              )}
                            </Button>
                          </>
                        )}
                      {approvalType &&
                        approvalType === "to-customer-approval" &&
                        currentUser.roles.INSPECTION_REPORT
                          .CUSTOMER_APPROVAL && (
                          <>
                            <Button
                              backgroundColor="success"
                              color="white"
                              fontSize="medium"
                              margin="10px 0px 0px 10px"
                              onClick={onApproval}
                            >
                              {t("inspectionReportApproval.approve")}
                            </Button>
                            <Button
                              backgroundColor="secondary"
                              color="white"
                              fontSize="medium"
                              margin="10px 0px 0px 10px"
                              onClick={() =>
                                document
                                  .getElementById("fileToApproveInput")
                                  .click()
                              }
                            >
                              <input
                                id="fileToApproveInput"
                                type="file"
                                onChange={(e) => {
                                  setUploadedFileToApprove(e.target.files[0]);
                                }}
                                className="file-upload-button"
                              />
                              {t(
                                "inspectionReportApproval.approveWithSignedDoc"
                              )}
                            </Button>
                          </>
                        )}
                    </>
                  )}
                  {reportToApproval.next_workflow_status ===
                    "to-tpi-approval" &&
                    currentUser.roles.INSPECTION_REPORT.TPI_APPROVAL && (
                      <>
                        <Button
                          backgroundColor="success"
                          color="white"
                          fontSize="medium"
                          margin="10px 0px 0px 10px"
                          onClick={onApproval}
                        >
                          {t("inspectionReportApproval.approve")}
                        </Button>
                        <Button
                          backgroundColor="secondary"
                          color="white"
                          fontSize="medium"
                          margin="10px 0px 0px 10px"
                          onClick={() =>
                            document
                              .getElementById("fileToApproveInput")
                              .click()
                          }
                        >
                          <input
                            id="fileToApproveInput"
                            type="file"
                            onChange={(e) => {
                              setUploadedFileToApprove(e.target.files[0]);
                            }}
                            className="file-upload-button"
                          />
                          {t("inspectionReportApproval.approveWithSignedDoc")}
                        </Button>
                      </>
                    )}
                  <Button
                    backgroundColor="error"
                    color="white"
                    fontSize="medium"
                    margin="10px 0px 0px 10px"
                    onClick={onReject}
                  >
                    {t("inspectionReportApproval.reject")}
                  </Button>
                </FlexView>
              ) : null}
            </FlexView>
          </FlexView>
        </Card>
      ) : (
        <Card
          margin="16px 250px"
          alignItems="stretch"
          alignSelf="stretch"
          padding="16px"
        >
          <FlexView
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
            alignSelf="stretch"
          >
            <FlexView
              fontSize="big"
              flexDirection="row"
              alignItems="center"
              fontWeight="bold"
              margin="0px 0px 8px"
            >
              PDF
            </FlexView>
            <Icon
              name="expand"
              width="20px"
              height="20px"
              style={{ marginBottom: "5px" }}
              onClick={onExpandClick}
            />
          </FlexView>
        </Card>
      )}
      <InternalApprovalModal
        isOpen={showInternalApproveModal}
        onOutsideClick={toggleInternalApproveModal}
      />
      <ApprovalModal
        isOpen={showApproveModal}
        onOutsideClick={toggleApproveModal}
      />
      <RejectModal
        isOpen={showRejectModal}
        onOutsideClick={toggleRejectModal}
      />
      <LoadingOverlay visible={loading} />
    </FlexView>
  ) : null;
};

export default InspectionReportApprovalPage;
